/**
 * 批次升級混搭（批141 裁示 11）：勾到不同產品或不同出貨 channel 的站 → 後端 409 `mixed_batch`，
 * **不自動分組**（`version` 是整批共用的一個值，只在同產品、同 channel 之內有意義）。
 *
 * 本檔把 409 的 `detail.groups` 翻成一段給操作者看的說明：分成哪幾批、各有哪些站。
 */
import { ApiError } from '@/api/client'
import type { MixedBatchGroup } from '@/api/hosting'

/** 這個錯誤是不是 `mixed_batch`；是就回分組，否則 null。 */
export function mixedBatchGroups(e: unknown): MixedBatchGroup[] | null {
  if (!(e instanceof ApiError) || e.status !== 409 || !e.payload) return null
  const d = (e.payload as { detail?: unknown }).detail
  if (!d || typeof d !== 'object') return null
  const obj = d as { code?: unknown; groups?: unknown }
  if (obj.code !== 'mixed_batch' || !Array.isArray(obj.groups)) return null
  return obj.groups.filter(
    (g): g is MixedBatchGroup =>
      !!g && typeof g === 'object' && typeof (g as MixedBatchGroup).product === 'string' &&
      Array.isArray((g as MixedBatchGroup).sites),
  )
}

/**
 * 給對話框的純文字說明（對話框不過 markdown，別放 `**`）。
 * `productName` 把產品鍵翻成顯示名（查不到時由呼叫端決定退回什麼）。
 */
export function mixedBatchMessage(
  groups: MixedBatchGroup[],
  productName: (key: string) => string,
): string {
  const lines = groups.map(
    (g, i) =>
      `${i + 1}. ${productName(g.product)}／${g.update_channel || '（未知 channel）'}` +
      `（${g.sites.length} 站）：${g.sites.join('、')}`,
  )
  return (
    '一批只能升級同一個產品、同一個出貨 channel 的站台——版本號只在同一條 channel 之內有意義，' +
    '系統不會替你自動分組。\n\n這次勾到的站可以分成下列幾批，請分開各按一次：\n' +
    lines.join('\n')
  )
}
